(function () {
  'use strict';
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\u00a0/g, ' ');
  const words = { un: 1, uno: 1, una: 1, dos: 2, tres: 3, cuatro: 4, cinco: 5, seis: 6, siete: 7, ocho: 8, nueve: 9, diez: 10 };
  const count = '(?:[1-9]\\d?|un|uno|una|dos|tres|cuatro|cinco|seis|siete|ocho|nueve|diez)';
  const number = '(?:\\d{1,3}(?:[. ]\\d{3})+(?:,\\d+)?|\\d+(?:[.,]\\d+)?)';
  const numeric = value => words[value] || Number(value.replace(/ (\d{3})/g, '$1').replace(/\.(?=\d{3}(?:\D|$))/g, '').replace(',', '.'));
  const doubtful = /\b(posibilidad|posible|podria|proyecto|proyectad[oa]|potencial|convertir|ampliar|crear|no dispone|no tiene|sin dormitorios|sin habitaciones|sin banos)\b/;
  function parse(text) {
    const lines = normalize(text).split(/[\n;!?]+/).map(line => line.trim()).filter(Boolean);
    const unique = (patterns, limit) => {
      const values = new Set();
      for (const line of lines) {
        if (doubtful.test(line)) continue;
        for (const source of patterns) {
          for (const match of line.matchAll(new RegExp(source, 'g'))) {
            const value = numeric(match[1]);
            if (value > 0 && value <= limit) values.add(value);
          }
        }
      }
      return values.size === 1 ? [...values][0] : null;
    };
    const rooms = unique(['\\b(' + count + ')\\s+(?:habitacion(?:es)?|dormitorios?|alcobas?)\\b', '\\b(?:habitacion(?:es)?|dormitorios?|alcobas?)\\s*[:=-]\\s*(' + count + ')\\b'], 30);
    const baths = unique(['\\b(' + count + ')\\s+banos?\\b', '\\bbanos?\\s*[:=-]\\s*(' + count + ')\\b'], 20);
    const areaUnit = '\\s*(?:m2\\b|m²(?!\\w)|metros cuadrados\\b)';
    const built = unique(['\\b(?:superficie construida|sup[.]? construida|superficie de la vivienda)\\s*[:=-]?\\s*(' + number + ')' + areaUnit, '\\b(' + number + ')' + areaUnit + '\\s+(?:construidos|construidas|de superficie construida)\\b'], 100000);
    const land = unique(['\\b(?:terreno|parcela|finca|superficie de terreno|superficie del terreno)\\s*(?:de|con)?\\s*[:=-]?\\s*(' + number + ')' + areaUnit, '\\b(' + number + ')' + areaUnit + '\\s+(?:de terreno|de parcela|de finca)\\b'], 10000000);
    const heatingPatterns = [['pellets', /\bpellets?\b/], ['gasoil', /\b(?:gasoil|gasoleo)\b/], ['propano', /\bpropano\b/], ['bomba de calor', /\b(?:bomba de calor|aerotermia)\b/], ['eléctrica', /\b(?:electrica|electricos)\b/], ['leña', /\blena\b/], ['suelo radiante', /\bsuelo radiante\b/]];
    const heating = new Set();
    for (const line of lines) {
      if (doubtful.test(line) || !/\bcalefaccion\b/.test(line) || /\b(?:sin calefaccion|no tiene calefaccion)\b/.test(line)) continue;
      for (const [value, pattern] of heatingPatterns) if (pattern.test(line)) heating.add(value);
    }
    const orientations = new Set();
    const directions = { norte: 'N', noreste: 'NE', este: 'E', sureste: 'SE', sur: 'S', suroeste: 'SO', oeste: 'O', noroeste: 'NO', n: 'N', ne: 'NE', e: 'E', se: 'SE', s: 'S', so: 'SO', o: 'O', no: 'NO' };
    for (const line of lines) {
      if (doubtful.test(line)) continue;
      for (const match of line.matchAll(/\borientacion(?: principal)?\s*[:=-]?\s*(noreste|noroeste|sureste|suroeste|norte|este|sur|oeste|ne|no|se|so|n|e|s|o)\b/g)) orientations.add(directions[match[1]]);
    }
    return { rooms, baths, built, land, heating: heating.size === 1 ? [...heating][0] : null, orientation: orientations.size === 1 ? [...orientations][0] : null };
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = parse; return; }
  function enhance(root) {
    if (!root || root.dataset.okhomesDescriptionReady) return;
    const description = root.querySelector('.okhomes-property-content .product__description');
    const config = root.querySelector('[data-okhomes-description-labels]');
    if (!description || !config) return;
    let labels;
    try { labels = JSON.parse(config.textContent); } catch (error) { return; }
    root.dataset.okhomesDescriptionReady = 'true';
    const data = parse(description.innerText);
    const summary = root.querySelector('.okhomes-property-summary--product');
    let facts = root.querySelector('.okhomes-property-facts');
    const existing = normalize(facts?.textContent);
    const guards = { rooms: /habitaci|dormitorio|alcoba/, baths: /bano/, built: /m²|m2|construid|superficie/, land: /terreno|parcela|finca/, heating: /calefacci|pellet|gasoil|gasoleo|propano|bomba de calor|suelo radiante/, orientation: /orientaci/ };
    const formatted = value => new Intl.NumberFormat('es-ES', { maximumFractionDigits: 2 }).format(value);
    const rows = [];
    for (const key of Object.keys(guards)) {
      if (!data[key] || guards[key].test(existing)) continue;
      if (key === 'rooms' && summary?.dataset.rooms) continue;
      if (key === 'baths' && summary?.dataset.baths) continue;
      if (key === 'built' && summary?.dataset.area && summary.dataset.areaKind === 'construida') continue;
      if (key === 'land' && summary?.dataset.area && summary.dataset.areaKind === 'parcela') continue;
      if (key === 'heating' && /calefacci/.test(normalize(root.querySelector('.okhomes-property-more')?.textContent))) continue;
      const value = typeof data[key] === 'number' ? formatted(data[key]) : data[key];
      rows.push([key, labels[key] + ': ' + value + (key === 'built' || key === 'land' ? ' m²' : '')]);
    }
    if (!rows.length) return;
    if (!facts) {
      const heading = document.createElement('h2');
      heading.className = 'okhomes-property-heading'; heading.textContent = labels.heading;
      facts = document.createElement('ul'); facts.className = 'okhomes-property-facts'; facts.setAttribute('aria-label', labels.heading);
      const content = root.querySelector('.okhomes-property-content'); content.before(heading, facts);
    }
    for (const [key, text] of rows) {
      const row = document.createElement('li'); row.textContent = text; row.dataset.okhomesDescriptionFact = key; facts.append(row);
    }
    if (summary) {
      for (const [key, selector] of [['rooms', 'Hab.'], ['baths', 'Baños']]) {
        if (!data[key] || summary.dataset[key] || guards[key].test(existing)) continue;
        const placeholder = [...summary.querySelectorAll('.okhomes-property-summary__unknown')].find(el => el.textContent.startsWith(selector));
        if (placeholder) { placeholder.textContent = data[key] + (key === 'rooms' ? ' hab.' : ' baños'); placeholder.classList.remove('okhomes-property-summary__unknown'); summary.dataset[key] = data[key]; }
      }
    }
  }
  const start = () => document.querySelectorAll('product-info').forEach(enhance);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  document.addEventListener('shopify:section:load', start);
})();
